import dayjs from 'dayjs';
import { debug } from 'zf-web-infra';
import type { ReactElement, ReactNode } from 'react';
import type { ColumnProps } from 'antd/es/table';
import type { DayProps } from '../types';

export function Day<T>(props: DayProps<T>): ReactElement | null {
  debug.common('Day', props);
  return null;
}

Day.displayName = 'Day';

export function getDayProps<T>(child: ReactElement<ColumnProps<T>>): ColumnProps<T> {
  const { format } = child.props as DayProps<T>;
  return {
    ...child.props, render: (value): ReactNode => dayjs(value).format(format ?? 'YYYY-MM-DD')
  };
}
